import { render, staticRenderFns } from "./exportBasicReportTableOther.vue?vue&type=template&id=540d14f9&scoped=true"
import script from "./exportBasicReportTableOther.vue?vue&type=script&lang=js"
export * from "./exportBasicReportTableOther.vue?vue&type=script&lang=js"
import style0 from "./exportBasicReportTableOther.vue?vue&type=style&index=0&id=540d14f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d14f9",
  null
  
)

export default component.exports